import Vue from 'vue'
import VueRouter from 'vue-router'
import router from "./router";
import $ from 'jquery';
require('./assets/js/app.js');
window.jQuery = $;
window.$ = $;

import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';

import VueAuth from '@websanova/vue-auth'
import VueAuthOptions from './client/auth'
import axios from 'axios'
import VueAxios from 'vue-axios'
import lodash from "lodash"
import VueSweetalert2 from 'vue-sweetalert2';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueSlickCarousel from 'vue-slick-carousel'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret, faCartPlus, faSignOutAlt, faUserTie, faServer, faHistory, faStoreAlt, faUserShield, faLayerGroup, faUserFriends, faUsers, faEnvelope, faTools, faTrain, faCog } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import CKEditor from '@ckeditor/ckeditor5-vue2';

library.add(faUserSecret, faCartPlus, faSignOutAlt, faUserTie, faServer, faHistory, faStoreAlt, faUserShield, faLayerGroup, faUserFriends, faUsers, faEnvelope, faTools, faTrain, faCog)
Vue.component('font-awesome-icon', FontAwesomeIcon)


import store from "./store/index";
import App from './views/layouts/App.vue'


Vue.router = router
Vue.use(VueRouter);
Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

axios.defaults.baseURL = 'https://api.alfastar.kz/api/v1/'
axios.defaults.baseImageURL = 'https://api.alfastar.kz/'

// axios.defaults.baseURL = 'http://alfastar-admin.loc/api/v1/'
// axios.defaults.baseImageURL = 'http://alfastar-admin.loc/'


Vue.use(VueAuth, VueAuthOptions);
Vue.use(VueSweetalert2);
Vue.use(VueSlickCarousel)
Vue.use(VueAwesomeSwiper);

new Vue({
  el: '#app',
  store,
  render: h => h(App),
  router
});



// WEBPACK FOOTER //
// ./src/main.js